import { Image } from "react-bootstrap";
import gamepass from "./gamepass.png"
import intel from "./intel.png"
import legion from "./legion.png"

export const Gamepass = () => <div style={{width: "115px", height: "20px"}}><Image fluid src={gamepass} /></div>
export const Intel = () =>  <div style={{width: "42px", height: "17px"}}><Image fluid src={intel} /></div> 
export const Legion = () =>  <div style={{width: "74px", height: "14px"}}><Image fluid src={legion} /></div>